export enum CountryCode {
  GreatBritain = 'GB',
  UnitedKingdom = 'UK',
  Germany = 'DE',
  Italy = 'IT',
  France = 'FR',
  Netherlands = 'NL',
}
